var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailDisplayError = function SvgEmailDisplayError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 280,
    height: 162
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "email-display-error_svg__a",
    width: "412.6%",
    height: "412.6%",
    x: "-156.3%",
    y: "-126.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 15,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.34902 0 0 0 0 0.494118 0 0 0 0 0.968627 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.5,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.34902 0 0 0 0 0.494118 0 0 0 0 0.968627 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0.065592967 0 0 0 0 0.100739606 0 0 0 0 0.21562919 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "email-display-error_svg__b",
    d: "m15.737 12.726 9.067-9.067A2.136 2.136 0 1 0 21.781.637l-9.066 9.067L3.648.637A2.137 2.137 0 0 0 .626 3.659l9.066 9.067-9.066 9.066a2.137 2.137 0 0 0 3.022 3.023l9.067-9.067 9.066 9.067a2.139 2.139 0 0 0 3.023-3.023l-9.067-9.066z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M224.939 63.355h-.062l-35.364 15.1-48.386 20.662c-.382.16-.812.163-1.196.006l-49.92-20.71-36.233-15.034-.055-.024h-.062a2.158 2.158 0 0 0-2.157 2.156v93.648c0 1.19.966 2.156 2.157 2.157h171.278a2.158 2.158 0 0 0 2.156-2.157V65.511c0-1.19-.966-2.155-2.156-2.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M225.093 63.97a.305.305 0 0 1-.176-.054L139.722 4.583a1.545 1.545 0 0 0-1.765.003L53.376 63.915a.309.309 0 0 1-.354-.505l84.581-59.328a2.16 2.16 0 0 1 2.47-.004L225.27 63.41a.31.31 0 0 1-.176.561z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "m58.209 66.074 80.713-59.819 81.327 64.075-77.168 45.746-41.895-9.549z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M104.722 144.332H64.848a1.864 1.864 0 0 1-.006-3.726h39.88a1.863 1.863 0 1 1 .006 3.726h-.006zm-25.568-8.01H64.848a1.863 1.863 0 0 1-.005-3.726h14.311a1.863 1.863 0 1 1 .005 3.726h-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M140.058 99.392c-.303 0-.604-.058-.884-.173L89.395 78.564V13.912a2.16 2.16 0 0 1 2.157-2.156h95.496a2.16 2.16 0 0 1 2.157 2.156V78.61l-.094.04-48.143 20.559a2.351 2.351 0 0 1-.91.183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M140.058 99.546c-.323 0-.644-.062-.943-.184L89.241 78.667V13.912a2.312 2.312 0 0 1 2.31-2.31h95.497a2.31 2.31 0 0 1 2.31 2.31v64.8l-48.33 20.639a2.504 2.504 0 0 1-.97.195zm-50.2-21.29 49.492 20.536a1.89 1.89 0 0 0 1.438-.008l47.955-20.48V13.913a1.698 1.698 0 0 0-1.695-1.694H91.552c-.936 0-1.694.759-1.695 1.694v64.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M224.477 63.355h-.062l-35.364 15.1-48.386 20.662c-.382.16-.812.163-1.196.006l-49.92-20.71-36.233-15.034-.056-.024h-.06a2.158 2.158 0 0 0-2.157 2.156v93.648c0 1.19.966 2.156 2.157 2.157h171.278a2.158 2.158 0 0 0 2.156-2.157V65.511c0-1.19-.966-2.155-2.156-2.156zm1.54 95.804c0 .851-.69 1.54-1.54 1.54H53.199a1.54 1.54 0 0 1-1.54-1.54V65.511c0-.828.654-1.507 1.481-1.54l36.41 15.107 49.682 20.615c.538.219 1.14.215 1.676-.01l48.143-20.56 35.488-15.152a1.544 1.544 0 0 1 1.478 1.54v93.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M132.308 35.923H98.422a2.464 2.464 0 0 1 0-4.929h33.886a2.464 2.464 0 0 1 0 4.929zm-17.559-10.474H98.422a2.464 2.464 0 1 1 0-4.929h16.327a2.465 2.465 0 0 1 0 4.929z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M164.644 60.567h-51.753a2.464 2.464 0 0 1-.001-4.929h51.754a2.465 2.465 0 0 1 0 4.929zm0 11.398h-51.753a2.465 2.465 0 1 1 0-4.929h51.753a2.465 2.465 0 0 1 0 4.929z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.088,
    cy: 64.814,
    r: 24,
    fill: "#37A3BC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M5.608 23.388a.988.988 0 0 0-1.483.984l.764 5.602a.665.665 0 0 1-.017.247.61.61 0 0 1-.117.215L.477 35.504a.967.967 0 0 0-.063 1.194l.005.006a.964.964 0 0 0 1.129.372l3.089-1.048a.591.591 0 0 1 .597.134c.118.11.185.262.185.423l.12 11.006a.985.985 0 0 0 1.339.911l23.056-8.817a.99.99 0 0 0 .151-1.774l-.314-.187L5.608 23.388zm-1.093.93a.595.595 0 0 1 .891-.589L29.564 38.06l.321.19a.596.596 0 0 1-.09 1.065L6.738 48.133a.592.592 0 0 1-.804-.547l-.12-11.006a.945.945 0 0 0-.055-.32l23.472 2.698a.396.396 0 0 0 .176-.768L5.286 30.14a1.002 1.002 0 0 0-.007-.219l-.764-5.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M5.608 23.388a.988.988 0 0 0-1.483.984l.764 5.602a.665.665 0 0 1-.017.247.61.61 0 0 1-.117.215L.477 35.504a.967.967 0 0 0-.063 1.194l.005.006a.964.964 0 0 0 1.129.372l3.089-1.048a.591.591 0 0 1 .597.134c.118.11.185.262.185.423l.12 11.006a.985.985 0 0 0 1.339.911l23.056-8.817a.99.99 0 0 0 .151-1.774l-.314-.187L5.608 23.388zm-1.093.93a.595.595 0 0 1 .891-.589L29.564 38.06l.321.19a.596.596 0 0 1-.09 1.065L6.738 48.133a.592.592 0 0 1-.804-.547l-.12-11.006a.97.97 0 0 0-.308-.706c-.016-.016-.033-.03-.05-.045l-.002-.002a.984.984 0 0 0-.943-.173l-3.091 1.05a.577.577 0 0 1-.677-.226l-.003-.003a.574.574 0 0 1 .039-.716l4.277-5.067a.962.962 0 0 0 .118-.173l.002-.002a.94.94 0 0 0 .11-.378 1.002 1.002 0 0 0-.007-.219l-.764-5.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "m5.286 30.139 24.12 8.051a.396.396 0 0 1-.175.768L5.76 36.26l-.415-.048.046-.392.064.006.002.002 23.82 2.735-24.1-8.047-.002.002-.104-.036.125-.375.091.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "m274.602.138-24.164 14.336-.314.187a.987.987 0 0 0 .152 1.774l23.055 8.817c.302.115.64.075.907-.105a.981.981 0 0 0 .432-.806l.121-11.006a.595.595 0 0 1 .782-.557l3.089 1.048a.964.964 0 0 0 1.129-.372l.004-.006a.964.964 0 0 0-.063-1.194l-4.277-5.067a.622.622 0 0 1-.117-.216.642.642 0 0 1-.017-.247l.764-5.601a.99.99 0 0 0-1.483-.985zm1.092.93-.763 5.602c-.01.073-.013.146-.007.219l-24.121 8.051a.397.397 0 0 0 .175.768l23.473-2.697a.913.913 0 0 0-.055.32l-.121 11.005a.595.595 0 0 1-.804.547l-23.055-8.817a.594.594 0 0 1-.09-1.064l.321-.191L274.803.479a.592.592 0 0 1 .891.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "m274.602.138-24.164 14.336-.314.187a.987.987 0 0 0 .152 1.774l23.055 8.817c.302.115.64.075.907-.105a.981.981 0 0 0 .432-.806l.121-11.006a.595.595 0 0 1 .782-.557l3.089 1.048a.964.964 0 0 0 1.129-.372l.004-.006a.964.964 0 0 0-.063-1.194l-4.277-5.067a.622.622 0 0 1-.117-.216.642.642 0 0 1-.017-.247l.764-5.601a.99.99 0 0 0-1.483-.985zm1.092.93-.763 5.602a1.004 1.004 0 0 0 .028.411.914.914 0 0 0 .075.187h.002c.032.063.072.12.118.174l4.277 5.067c.179.2.194.498.038.716l-.002.003a.575.575 0 0 1-.677.226l-3.091-1.05a.984.984 0 0 0-.944.174v.001l-.051.045a.945.945 0 0 0-.253.387.937.937 0 0 0-.056.32l-.12 11.005a.595.595 0 0 1-.804.547l-23.055-8.817a.594.594 0 0 1-.09-1.064l.321-.191L274.803.479a.592.592 0 0 1 .891.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "m275.015 6.858.125.375-.104.036-.002-.001-24.1 8.046 23.82-2.735.001-.001.064-.007.046.393-.414.047-23.473 2.697a.396.396 0 0 1-.175-.768l24.12-8.051.092-.031z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212.12 52.12)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#email-display-error_svg__a)",
    xlinkHref: "#email-display-error_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#email-display-error_svg__b"
  })))));
};
export default SvgEmailDisplayError;